import CreateOrderPage from './CreateOrderPage.vue'
import OrdersPage from './OrdersPage.vue'
import OrderPage from './OrderPage.vue'


export default {
  routers() {
    return [
      {
        path: '/order',
        name: 'orderForm',
        component: CreateOrderPage
      },
      {
        path: '/account/orders',
        name: 'orders',
        component: OrdersPage
      },
      {
        path: '/account/order/:orderId',
        name: 'orderPage',
        component: OrderPage,
        props: true
      },
    ];
  }
}





// WEBPACK FOOTER //
// ./src/components/order/src/Router.js